const API_BASE = process.env.REACT_APP_API_URL || 'https://multi-counter.bancheng.tech/api';

export const getGlobalSettings = async () => {
  const response = await fetch(`${API_BASE}/global-settings`);
  if (!response.ok) {
    throw new Error('Failed to fetch global settings');
  }
  return response.json();
};

export const updateGlobalSettings = async (settings) => {
  const response = await fetch(`${API_BASE}/global-settings`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings)
  });
  if (!response.ok) {
    throw new Error('Failed to update global settings');
  }
  return response.json();
};
